export default __webpack_public_path__ + "static/media/playlist.3be342d4.svg";